// Deployment configuration for Kast Dev Admin: each field from, in order,
// a per-device override in localStorage (apiUrl only), window.RUNTIME_CONFIG
// (/config.js), the build's env (deploy.sh writes .env.production), then the
// default below.

import { cognitoFields, createDeploymentConfig } from "@jkast90/kast-common/config";

export const deploymentConfig = createDeploymentConfig({
  env: import.meta.env,
  fields: {
    apiUrl: {
      key: "VITE_WORKSPACE_API_BASE_URL",
      storageKey: "dashboard_api_url",
      // Only these two count as local here, as they always have.
      default: (c) =>
        c.hostname === "localhost" || c.hostname === "127.0.0.1"
          ? "https://localhost:8443"
          : `${c.protocol}//${c.hostname}`,
    },
    ...cognitoFields(),
  },
});

export const getDeploymentConfig = deploymentConfig.get;
